<template>
    <div class="monitor-container container-view" ref="pageView">
        <!-- title -->
        <section class="title-section">
            <p class="titleInfo fl">{{ curTime }}</p>
            <p class="titleText"></p>
        </section>
        <section class="main">
            <section class="chartPanel">
                <!--topLeft-->
                <div
                        class="chartPanel-child topLeft"
                        v-loading="topLeftLoading"
                        element-loading-background="rgba(0, 0, 0, 0.7)"
                >
                    <div class="wrapper">
                        <div class="left">
                            <p>应急车辆 / 司机数</p>
                            <p>执勤车辆 / 司机数</p>
                            <p>执行任务车辆 / 司机数</p>
                        </div>
                        <div class="center"></div>
                        <div class="right">
                            <p class="color_1">
                                {{ topLeftChartData.emergencyVehicleNum }} /
                                {{ topLeftChartData.emergencyDriverNum }}
                            </p>
                            <p class="color_2">598 / 1000</p>
                            <p class="color_3">12 / 15</p>
                        </div>
                    </div>
                </div>
                <!--topRight-->
                <div
                        class="chartPanel-child topRight"
                        v-loading="topRightLoading"
                        element-loading-background="rgba(0, 0, 0, 0.7)"
                >
                    <div class="wrapper">
                        <div class="item left">
                            <span class="num">25</span>
                            <span class="title">应急任务量</span>
                            <div class="chart" ref="topRightChartLeft"></div>
                        </div>
                        <div class="item middle">
                            <span class="num">10</span>
                            <span class="title">已完成任务量</span>
                            <div class="chart" ref="topRightChartMiddle"></div>
                        </div>
                        <div class="item right">
                            <span class="num">15</span>
                            <span class="title">执行中任务量</span>
                            <div class="chart" ref="topRightChartRight"></div>
                        </div>
                    </div>
                    <!-- <div class="chartPanel-child-chartArea" ref="topRightChartDOM"></div> -->
                </div>
                <!--centerMap-->
                <div
                        class="chartPanel-child middleCenter"
                        v-loading="mapLoading"
                        element-loading-background="rgba(0, 0, 0, 0.7)"
                >
                    <div class="chartPanel-child-chartArea" ref="mapChartDOM"></div>
                </div>
                <!--centerLeft-->
                <div
                        class="chartPanel-child centerLeft"
                        v-loading="centerLeftLoading"
                        element-loading-background="rgba(0, 0, 0, 0.7)"
                >
                    <div
                            class="chartPanel-child-chartArea"
                            ref="centerLeftChartDOM"
                    ></div>
                </div>
                <!-- centeRight -->
                <div
                        class="chartPanel-child centerRight"
                        v-loading="topLeftLoading"
                        element-loading-background="rgba(0, 0, 0, 0.7)"
                >
                    <div
                            class="chartPanel-child-chartArea"
                            ref="centerRightChartDOM"
                    ></div>
                </div>
                <!--bottomCenter-->
                <section
                        class="chartPanel-child bottomCenter"
                        v-loading="bottomCenterLoading"
                        element-loading-background="rgba(0, 0, 0, 0.7)"
                >
                    <p class="title">执行中的应急任务</p>
                    <el-carousel
                            height="100%"
                            :interval="30000"
                            indicator-position="none"
                    >
                        <el-carousel-item v-for="(value, name) in tableObj" :key="name">
                            <table class="chartPanel__table">
                                <thead>
                                <tr class="th-color">
                                    <th>任务编码</th>
                                    <th>发货地</th>
                                    <th>起运时间窗</th>
                                    <th>收货地</th>
                                    <th>收获时间窗</th>
                                    <th>执行任务车辆</th>
                                    <th>司机</th>
                                    <th>当前状态</th>
                                    <th>预计到达时间</th>
                                    <th>进度</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item, index) in value" :key="index">
                                    <td class="th-color">{{ item.areaName }}</td>
                                    <td>{{ item.startArea }}</td>
                                    <td>{{ item.startTime }}</td>
                                    <td>{{ item.endArea }}</td>
                                    <td>{{ item.endTime }}</td>
                                    <td>{{ item.licenseId }}</td>
                                    <td>{{ item.dirveName }}</td>
                                    <td>{{ item.status }}</td>
                                    <td>{{ item.planTime }}</td>
                                    <td>{{ item.progress }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </el-carousel-item>
                    </el-carousel>
                </section>
            </section>
        </section>
    </div>
</template>

<script>
    // plugin
    import moment from "moment";
    import Echarts from "echarts";
    import {mapGetters, mapMutations} from "vuex";

    // interface
    import {
        FetchTopComparyBlackOrder,
        FetchAlarmLocation,
        FetchAlarmByLocation,
        FetchAlarmByScenes
    } from "@/api/board/alarm";

    import {
        getEmergencyVehicleAndDriver,
        getEmergencyVehicleAndDriverOfCompary
    } from "@/api/emergencyManage/transportMonitorBoard.js";

    // mixins
    import resizeListener from "_private/mixins/resizeListener";

    // charts setting
    import {handleMapData} from "../../board/alarm/chartConfig.js";

    // Global Variable
    const OPTION_CHART = {
        tooltip: {
            formatter: "{a} <br/>{b} : {c}%"
        },
        series: [
            {
                name: "业务指标",
                type: "gauge",
                max: 50,
                splitNumber: 18,
                detail: {
                    show: false
                },
                data: [{value: 250}],
                axisLine: {
                    lineStyle: {
                        color: [
                            [
                                1,
                                new Echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                    {
                                        offset: 0.1,
                                        color: "#f1bb4c"
                                    },
                                    {
                                        offset: 1,
                                        color: "#d76b14"
                                    }
                                ])
                            ]
                        ],
                        width: 10
                    }
                },
                splitLine: {
                    length: 10,
                    lineStyle: {
                        width: 2,
                        color: "#161b44"
                    }
                },
                axisLabel: {
                    distance: -20,
                    show: false,
                    formatter: function (value) {
                        if (value === 0 || value === 50) {
                            return value + "℃";
                        }
                        return "";
                    },
                    //   padding: '8 0 0 0'
                    lineHeight: -60,
                    fontSize: 40
                },
                pointer: {
                    show: false
                },
                axisTick: {
                    show: false
                }
            },
            {
                //进度圆环
                name: "Line 1",
                type: "pie",
                startAngle: -135,
                clockWise: true,
                radius: ["71%", "72%"],
                itemStyle: {
                    normal: {
                        label: {
                            show: false
                        },
                        labelLine: {
                            show: false
                        }
                    }
                },
                hoverAnimation: false,

                data: [
                    {
                        value: 50,
                        itemStyle: {
                            normal: {
                                color: "transparent"
                            }
                        }
                    },
                    {
                        //画中间的图标
                        name: "",
                        value: 0,
                        label: {
                            position: "inside",
                            backgroundColor: "#53adf4",
                            width: 16,
                            height: 16,
                            borderRadius: 20,
                            borderColor: "#fff",
                            borderWidth: 4,
                            padding: 8
                        }
                    },
                    {
                        value: 17,
                        name: "invisible",
                        itemStyle: {
                            normal: {
                                color: "transparent", //未完成的圆环的颜色
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            }
                        }
                    }
                ]
            }
        ]
    };

    export default {
        mixins: [resizeListener],

        data() {
            return {
                curTime: moment().format("YYYY-MM-DD HH:mm:ss"),
                timeInterval: null, // 时间显示定时器
                resizeTimer: null, // resize事件节流timer
                clientWidth: document.documentElement.clientWidth, // 页面宽度
                clientHeight: document.documentElement.clientHeight, // 页面高度
                reloadDataTime: 1000 * 60 * 60, // 刷新数据时间间隔

                /************ topLeft ****************/
                topLeftChartInstance: null, // 左上角图表实例
                topLeftLoading: false, // 左上角数据正在加载
                topLeftChartData: {
                    emergencyDriverNum: 0,
                    emergencyVehicleNum: 0
                },
                topLeftTimelineData: ["昨日", "近7日", "近1月"],
                topLeftTimelineActiveIndex: 0,

                /*********** topRight ********************/
                topRightLeftChartInstance: null, // 左
                topRightMiddleChartInstance: null, // 中
                topRightRightChartInstance: null, // 右
                topRightChartInstance: null, // 右上角图表实例
                topRightLoading: false, // 右上角数据正在加载
                topRightChartData: {
                    lastDateData: [],
                    last7DateData: [],
                    lastMouthData: []
                },

                /*********** centerLeft ********************/
                centerLeftChartInstance: null, // 左下角图表实例
                centerLeftLoading: false, // 左下角数据正在加载
                centerLeftChartData: [],
                loopData: [],
                count: 10,
                centerLeftTimer: null,

                /*********** bottomCenter ********************/

                bottomCenterLoading: false, // 左中部数据正在加载
                tableObj: {},

                /*********** centerRight ********************/
                centerRightChartInstance: null, // 右下角图表实例
                centerRightLoading: false, // 右下角数据正在加载
                centerRightChartData: {
                    lastDateData: {},
                    last7DateData: {},
                    lastMouthData: {}
                },
                centerRightTimelineData: ["昨日", "近7日", "近1月"],
                centerRightTimelineActiveIndex: 0,

                /************* centerMap ********************/
                fetchMapChartDataTimer: null,
                mapChartInstance: null, // 地图图表实例
                mapChartData: {
                    freezerList: [],
                    storageList: [],
                    vehicleList: []
                },
                mapLoading: false,
                mapChartHighlightTimer: null,

                pageWidth: 0
            };
        },

        created() {
            !this.isFullScreen && this.updateFullScreen();
        },

        mounted() {
            this.initCenterMap(); // 初始化中间地图geo数据，获取业务数据
            this.pageWidth = this.$refs.pageView.clientWidth;
        },

        beforeDestroy() {
            clearInterval(this.timeInterval); // 清除定时器
            clearInterval(this.mapChartHighlightTimer);
            clearTimeout(this.centerLeftTimer);
            this.centerLeftTimer = null;
        },

        computed: {
            ...mapGetters(["isFullScreen"])
        },

        methods: {
            ...mapMutations(["updateFullScreen"]),

            // 设置左上角钟表定时器
            setCLockTimeInterval() {
                clearInterval(this.timeInterval);
                // 设置定时器，每个1秒获取一次时间信息
                this.timeInterval = setInterval(() => {
                    this.curTime = moment().format("YYYY-MM-DD HH:mm:ss");
                }, 1000);
            },

            // 监控浏览器及元素变化
            resizeListener() {
                this.pageWidth = this.$refs.pageView.clientWidth;

                clearTimeout(this.resizeTimer);

                this.resizeTimer = setTimeout(() => {
                    this.$nextTick(() => {
                        this.clientWidth = document.documentElement.clientWidth;
                        this.clientHeight = document.documentElement.clientHeight;

                        this.topLeftChartInstance && this.topLeftChartInstance.resize();
                        this.topRightChartInstance && this.topRightChartInstance.resize();
                        this.centerLeftChartInstance && this.centerLeftChartInstance.resize();
                        this.topRightLeftChartInstance &&
                        this.topRightLeftChartInstance.resize();
                        this.topRightMiddleChartInstance &&
                        this.topRightMiddleChartInstance.resize();
                        this.topRightRightChartInstance &&
                        this.topRightRightChartInstance.resize();

                        this.centerRightChartInstance &&
                        this.centerRightChartInstance.resize();
                        this.mapChartInstance && this.mapChartInstance.resize();
                    });
                }, 300);
            },

            /************************** topLeft ************************************/
            // 获取topLeft数据
            fetchTopLeftChartData() {
                this.topLeftLoading = true;
                getEmergencyVehicleAndDriver()
                    .then(({code, result, message}) => {
                        if (code === 1 && result) {
                            this.topLeftChartData = result;
                        } else {
                            this.errorMessage(message || "获取企业红榜TOP10数据失败");
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.errorMessage("获取企业红榜TOP10数据失败");
                    })
                    .finally(() => {
                        this.topLeftLoading = false;
                    });
            },

            /************************** topRight ************************************/
            // 获取企业黑榜TOP10数据
            fetchTopRightData() {
                this.topRightLoading = true;
                FetchTopComparyBlackOrder()
                    .then(({code, result, message}) => {
                        if (code === 1 && result) {
                            // result = {
                            //   lastDateData: [
                            //     { alarmCount: 95, companyName: "入驻企业2" },
                            //     { alarmCount: 89, companyName: "入驻企业4" },
                            //     { alarmCount: 73, companyName: "入驻企业6" },
                            //     { alarmCount: 64, companyName: "入驻企业8" },
                            //     { alarmCount: 55, companyName: "入驻企业10" },
                            //     { alarmCount: 47, companyName: "入驻企业12" },
                            //     { alarmCount: 39, companyName: "入驻企业14" },
                            //     { alarmCount: 20, companyName: "入驻企业16" },
                            //     { alarmCount: 14, companyName: "入驻企业18" },
                            //     { alarmCount: 6, companyName: "入驻企业20" }
                            //   ],
                            //   last7DateData: [
                            //     { alarmCount: 976, companyName: "入驻企业2" },
                            //     { alarmCount: 854, companyName: "入驻企业4" },
                            //     { alarmCount: 798, companyName: "入驻企业6" },
                            //     { alarmCount: 610, companyName: "入驻企业8" },
                            //     { alarmCount: 523, companyName: "入驻企业10" },
                            //     { alarmCount: 456, companyName: "入驻企业12" },
                            //     { alarmCount: 355, companyName: "入驻企业14" },
                            //     { alarmCount: 265, companyName: "入驻企业16" },
                            //     { alarmCount: 198, companyName: "入驻企业18" },
                            //     { alarmCount: 56, companyName: "入驻企业20" }
                            //   ],
                            //   lastMouthData: [
                            //     { alarmCount: 9754, companyName: "入驻企业2" },
                            //     { alarmCount: 8451, companyName: "入驻企业4" },
                            //     { alarmCount: 7941, companyName: "入驻企业6" },
                            //     { alarmCount: 6545, companyName: "入驻企业8" },
                            //     { alarmCount: 5987, companyName: "入驻企业10" },
                            //     { alarmCount: 4349, companyName: "入驻企业12" },
                            //     { alarmCount: 3876, companyName: "入驻企业14" },
                            //     { alarmCount: 2711, companyName: "入驻企业16" },
                            //     { alarmCount: 1673, companyName: "入驻企业18" },
                            //     { alarmCount: 1001, companyName: "入驻企业20" }
                            //   ]
                            // };
                            this.topRightChartData = result;
                        } else {
                            this.errorMessage(message || "获取企业黑榜TOP10数据失败");
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.errorMessage("获取企业黑榜TOP10数据失败");
                    })
                    .finally(() => {
                        this.topRightLoading = false;
                        this.initTopRightChart();
                    });
            },
            // 初始化右上角图表
            initTopRightChart() {
                this.initTopRightLeftChart();
                this.initTopRightMiddleChart();
                this.initTopRightRightChart();
            },

            initTopRightLeftChart() {
                if (this.topRightLeftChartInstance) {
                    this.topRightLeftChartInstance.clear();
                } else {
                    this.topRightLeftChartInstance = Echarts.init(
                        this.$refs.topRightChartLeft
                    );
                    this.topRightLeftChartInstance.setOption({
                        OPTION_CHART
                    });
                }
                OPTION_CHART.series[0].axisLine.lineStyle.color = [
                    [
                        1,
                        new Echarts.graphic.LinearGradient(0, 0, 1, 0, [
                            {
                                offset: 0.1,
                                color: "#f1bb4c"
                            },
                            {
                                offset: 1,
                                color: "#d76b14"
                            }
                        ])
                    ]
                ];
                // let num = 50;
                // OPTION_CHART.series[0].data[0].value = num;
                // OPTION_CHART.series[1].data[0].value = num;
                // OPTION_CHART.series[1].data[2].value = 67 - num;
                this.topRightLeftChartInstance.setOption(OPTION_CHART, true);
            },

            initTopRightMiddleChart() {
                if (this.topRightMiddleChartInstance) {
                    this.topRightMiddleChartInstance.clear();
                } else {
                    this.topRightMiddleChartInstance = Echarts.init(
                        this.$refs.topRightChartMiddle
                    );
                    this.topRightMiddleChartInstance.setOption({
                        OPTION_CHART
                    });
                }

                OPTION_CHART.series[0].axisLine.lineStyle.color = [
                    [
                        1,
                        new Echarts.graphic.LinearGradient(0, 0, 1, 0, [
                            {
                                offset: 0.1,
                                color: "#008aff"
                            },
                            {
                                offset: 1,
                                color: "#4348ff"
                            }
                        ])
                    ]
                ];

                // let num = 50;
                // OPTION_CHART.series[0].data[0].value = num;
                // OPTION_CHART.series[1].data[0].value = num;
                // OPTION_CHART.series[1].data[2].value = 67 - num;
                this.topRightMiddleChartInstance.setOption(OPTION_CHART, true);
            },

            initTopRightRightChart() {
                if (this.topRightRightChartInstance) {
                    this.topRightLeftChartInstance.clear();
                } else {
                    this.topRightRightChartInstance = Echarts.init(
                        this.$refs.topRightChartRight
                    );
                    this.topRightRightChartInstance.setOption({
                        OPTION_CHART
                    });
                }

                OPTION_CHART.series[0].axisLine.lineStyle.color = [
                    [
                        1,
                        new Echarts.graphic.LinearGradient(0, 0, 1, 0, [
                            {
                                offset: 0.1,
                                color: "#3feed4"
                            },
                            {
                                offset: 1,
                                color: "#00a14c"
                            }
                        ])
                    ]
                ];
                // let num = 50;
                // OPTION_CHART.series[0].data[0].value = num;
                // OPTION_CHART.series[1].data[0].value = num;
                // OPTION_CHART.series[1].data[2].value = 67 - num;
                this.topRightRightChartInstance.setOption(OPTION_CHART, true);
            },

            /************************** centerMap ************************************/
            // 初始化中间地图geo数据，获取业务数据
            async initCenterMap() {
                // 获取地区内部/外部轮廓地理位置信息
                let geoDirName = this.$GLOBAL_CONFIG.displayBoard.alarmStatic.map
                    .geoDirName; // geo文件件
                let geoPromises = [
                    import(`@/assets/geo/${geoDirName}/inline.json`),
                    import(`@/assets/geo/${geoDirName}/outline.json`)
                ];
                let [inlineGeo, outlineGeo] = await Promise.all(geoPromises);

                // 初始化地图
                Echarts.registerMap("inlineMap", inlineGeo);
                Echarts.registerMap("outlineMap", outlineGeo);

                // 获取地图业务数据
                this.fetchTopLeftChartData();
                this.fetchTopRightData();
                this.fetchCenterMapData();
                this.fetchBottomCenterData();
                this.fetchBottomLeftData();
                this.fetchBottomRightData();
                this.setCLockTimeInterval();
            },
            // 获取中部地图数据
            fetchCenterMapData() {
                clearInterval(this.fetchMapChartDataTimer);
                const fetchDataFun = () => {
                    this.mapLoading = true;
                    FetchAlarmLocation()
                        .then(({code, result, message}) => {
                            if (code === 1 && result) {
                                result = {
                                    freezerLonLatList: [
                                        {
                                            lat: 22.479614,
                                            lon: 114.055293,
                                            name: "河南众荣门店1",
                                            subsetName: "河南众荣冷柜1,河南众荣冷柜2,河南众荣冷柜3"
                                        },
                                        {
                                            lat: 22.379614,
                                            lon: 114.037263,
                                            name: "河南众荣门店1",
                                            subsetName: "河南众荣冷柜1,河南众荣冷柜2,河南众荣冷柜3"
                                        },
                                        {
                                            lat: 22.529614,
                                            lon: 114.557263,
                                            name: "河南众荣门店1",
                                            subsetName: "河南众荣冷柜1,河南众荣冷柜2,河南众荣冷柜3"
                                        }
                                    ],
                                    storageLonLatList: [
                                        {
                                            lat: 34.77,
                                            lon: 112.98,
                                            name: "测试冷冻库1"
                                        },
                                        {
                                            lat: 34.75,
                                            lon: 113.67,
                                            name: "测试冷冻库2"
                                        },
                                        {
                                            lat: 45.221,
                                            lon: 113.57,
                                            name: "伊利22仓库01"
                                        },
                                        {
                                            lat: 45.321,
                                            lon: 113.27,
                                            name: "伊利仓库0221"
                                        }
                                    ],
                                    vehicleLonLatList: [
                                        {
                                            lat: 34.778823,
                                            lon: 113.70728,
                                            name: "陕A12345"
                                        },
                                        {
                                            lat: 34.728823,
                                            lon: 113.70358,
                                            name: "陕A1ewr"
                                        },
                                        {
                                            lat: 35.772823,
                                            lon: 116.70128,
                                            name: "陕Frewr"
                                        },
                                        {
                                            lat: 34.128823,
                                            lon: 113.70343,
                                            name: "陕fdsff23"
                                        },
                                        {
                                            lat: 37.772823,
                                            lon: 113.79328,
                                            name: "陕A15f45"
                                        }
                                    ]
                                };
                                this.mapChartData = {
                                    freezerList: handleMapData(result.freezerLonLatList || []),
                                    storageList: handleMapData(result.storageLonLatList || []),
                                    vehicleList: handleMapData(result.vehicleLonLatList || [])
                                };
                            } else {
                                this.errorMessage(message || "获取地图数据失败");
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            this.errorMessage("获取地图数据失败");
                        })
                        .finally(() => {
                            this.mapLoading = false;
                            this.initMapChart();
                        });
                };
                fetchDataFun();
                this.fetchMapChartDataTimer = setInterval(fetchDataFun, 1e3 * 60 * 3);
            },
            // 初始化中部地图
            initMapChart() {
                if (this.mapChartInstance) {
                    this.mapChartInstance.clear();
                } else {
                    this.mapChartInstance = Echarts.init(this.$refs.mapChartDOM);
                }
                const mapChartData = this.mapChartData;
                const option = {
                    legend: {
                        data: ["车辆", "冷库", "冷柜"],
                        textStyle: {
                            color: "#7b89dc"
                        },
                        top: this.calcYDirectionSizeByPercent(40)
                    },
                    tooltip: {
                        show: true
                    },
                    geo: [
                        {
                            name: "inlineMap",
                            type: "map",
                            map: "inlineMap",
                            roam: false,
                            zoom: 1,
                            top: this.calcYDirectionSizeByPercent(74),
                            right: "5%",
                            bottom: "1%",
                            left: "5%",
                            tooltip: {
                                show: false
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: "inside", //显示位置
                                    offset: [0, 0], //偏移设置
                                    color: "#7b89dc",
                                    // formatter: "{b}", //圆环显示文字
                                    fontWeight: "lighter",
                                    fontSize: 12
                                },
                                emphasis: {
                                    color: "#ffffff",
                                    show: true
                                }
                            },
                            itemStyle: {
                                normal: {
                                    borderColor: "#3d59cd",
                                    borderWidth: 1,
                                    areaColor: "rgba(65, 82, 245, 0.2)",
                                    shadowColor: "rgba(51, 69, 255, 0.5)",
                                    // shadowColor: 'rgba(255, 255, 255, 1)',
                                    // shadowOffsetX: -2,
                                    // shadowOffsetY: 2,
                                    shadowBlur: 10
                                },
                                emphasis: {
                                    areaColor: "rgba(65, 82, 245, 0.5)"
                                    // borderWidth: 0
                                }
                            }
                        },
                        {
                            map: "outlineMap",
                            roam: false,
                            zoom: 1,
                            top: this.calcYDirectionSizeByPercent(74),
                            right: "5%",
                            bottom: "1%",
                            left: "5%",
                            label: {
                                show: false,
                                emphasis: {
                                    show: false
                                }
                            },
                            itemStyle: {
                                normal: {
                                    borderColor: "#4a75ff",
                                    borderWidth: 5,
                                    areaColor: "rgba(65, 82, 245, 0)",
                                    shadowColor: "rgba(51, 69, 255, 1)",
                                    shadowBlur: 20
                                },
                                emphasis: {
                                    areaColor: "rgba(0, 0, 0, 0)"
                                }
                            },
                            hoverAnimation: false,
                            show: true
                        }
                    ],
                    series: [
                        {
                            name: "车辆",
                            type: "scatter",
                            coordinateSystem: "geo",
                            hoverAnimation: false,
                            itemStyle: {
                                color: "#3feed4",
                                shadowBlur: 2,
                                opacity: 0.3,
                                shadowColor: "#ffffff"
                            },
                            emphasis: {
                                itemStyle: {
                                    opacity: 1,
                                    shadowBlur: 7
                                }
                            },
                            tooltip: {
                                show: true,
                                formatter: params => {
                                    let result = "";
                                    result +=
                                        '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                                        params.color +
                                        '"></span>';
                                    result += params.seriesName + "：" + params.name + "<br>";
                                    return result;
                                }
                            },
                            data: mapChartData.vehicleList
                        },
                        {
                            name: "冷库",
                            type: "scatter",
                            coordinateSystem: "geo",
                            hoverAnimation: false,
                            itemStyle: {
                                color: "#afa3f5",
                                shadowBlur: 2,
                                opacity: 0.3,
                                shadowColor: "#ffffff"
                            },
                            emphasis: {
                                itemStyle: {
                                    opacity: 1,
                                    shadowBlur: 7
                                }
                            },
                            tooltip: {
                                show: true,
                                formatter: params => {
                                    let result = "";
                                    result +=
                                        '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                                        params.color +
                                        '"></span>';
                                    result += params.seriesName + "：" + params.name + "<br>";
                                    return result;
                                }
                            },
                            data: mapChartData.storageList
                        },
                        {
                            name: "冷柜",
                            type: "scatter",
                            coordinateSystem: "geo",
                            hoverAnimation: false,
                            itemStyle: {
                                color: "#f1bb4c",
                                shadowBlur: 2,
                                opacity: 0.3,
                                shadowColor: "#ffffff"
                            },
                            emphasis: {
                                itemStyle: {
                                    opacity: 1,
                                    shadowBlur: 7
                                }
                            },
                            tooltip: {
                                show: true,
                                formatter: params => {
                                    let result = "";
                                    result +=
                                        '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                                        params.color +
                                        '"></span>';
                                    if (params.data.subsetName) {
                                        result += params.seriesName + "：" + params.name + "<br />";
                                        result += params.data.subsetName;
                                    } else {
                                        result += params.seriesName + "：" + params.name + "<br />";
                                    }
                                    return result;
                                },
                                extraCssText: "width:300px; white-space:pre-wrap" // 额外添加到浮层的css样式，用于换行。
                            },
                            data: mapChartData.freezerList
                        }
                    ]
                };

                this.mapChartInstance.setOption(option);

                clearInterval(this.mapChartHighlightTimer);
                let highlightIndex = 0;
                this.mapChartHighlightTimer = setInterval(() => {
                    // 设置高亮
                    this.mapChartInstance.dispatchAction({
                        type: "highlight",
                        seriesIndex: highlightIndex % 3
                    });
                    // 取消上一个高亮
                    this.mapChartInstance.dispatchAction({
                        type: "downplay",
                        seriesIndex: (highlightIndex - 1) % 3
                    });

                    highlightIndex++;
                }, 1e3);
            },

            /************************** centerLeft ************************************/
            // 获取各企业应急动力数据
            fetchBottomLeftData() {
                this.centerLeftLoading = true;
                this.centerLeftChartData = [];
                this.loopData = [];
                getEmergencyVehicleAndDriverOfCompary()
                    .then(({code, result, message}) => {
                        if (code === 1 && result) {
                            this.centerLeftChartData = result;
                        } else {
                            this.errorMessage(
                                message || "获取车/库/柜近7日报警数量统计数据失败"
                            );
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.errorMessage("获取车/库/柜近7日报警数量统计数据失败");
                    })
                    .finally(() => {
                        this.centerLeftLoading = false;
                        this.loopData = this.centerLeftChartData.slice(0, this.count);
                        this.initCenterLeftChart(this.loopData);
                        this.centerLeftChartData.length > 10 && this.handleLoopData();
                    });
            },
            // 初始化底部左侧图表
            initCenterLeftChart(data) {
                let labelData = [];
                let vehicleData = [];
                let driverData = [];
                data.forEach(item => {
                    labelData.push(item.comparyName);
                    vehicleData.push(-item.emergencyVehicleNum);
                    driverData.push(item.emergencyDriverNum);
                });

                if (this.centerLeftChartInstance) {
                    this.centerLeftChartInstance.clear();
                } else {
                    this.centerLeftChartInstance = Echarts.init(
                        this.$refs.centerLeftChartDOM
                    );
                }
                this.centerLeftChartInstance.setOption({
                    title: {
                        text: "各企业应急运力",
                        textStyle: {
                            color: "#bad7ff",
                            fontSize: this.calcXDirectionSizeByPercent(16),
                            lineHeight: this.calcYDirectionSizeByPercent(30)
                        },
                        padding: [
                            this.calcYDirectionSizeByPercent(2),
                            this.calcXDirectionSizeByPercent(0),
                            0,
                            this.calcXDirectionSizeByPercent(10)
                        ]
                    },
                    legend: {
                        // show: false,

                        x: "center",
                        y: "11%",
                        data: ["应急车辆数", "应急司机数"],
                        margin: 100,
                        itemGap: 50,
                        itemWidth: 0,
                        textStyle: {
                            color: "#bad7ff",
                            fontSize: 16
                        }
                    },
                    // tooltip（提示框组件）
                    tooltip: {
                        //trigger(触发类型)，可选'item','axis','none'
                        trigger: "axis",
                        axisPointer: {
                            //指示器类型,可选'line','shadow','cross'
                            type: "shadow"
                        },
                        // 自定义提示内容
                        formatter: function (a) {
                            var v = a[0];
                            return (
                                v.name +
                                "<br/>" +
                                v.marker +
                                v.seriesName +
                                "：" +
                                Math.abs(v.value)
                            );
                        }
                    },
                    xAxis: [
                        {
                            type: "value",
                            // min: -100,
                            max: 0,
                            gridIndex: 0,
                            axisTick: {show: false, inside: false},
                            axisLabel: {show: false},
                            axisLine: {
                                // Y轴轴线样式
                                show: false,
                                lineStyle: {
                                    color: "#000"
                                }
                            },
                            splitLine: {
                                show: false
                            }
                        },
                        {
                            type: "value",
                            gridIndex: 1,
                            min: 0,
                            // max: 100,
                            axisTick: {show: false}, //是否显示刻度
                            axisLine: {
                                // Y轴轴线样式
                                show: false, // 是否显示X轴
                                lineStyle: {
                                    color: "#000"
                                }
                            },
                            axisLabel: {
                                show: false //是否显示X轴内容
                            },
                            splitLine: {
                                show: false
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: "category",
                            gridIndex: 0,
                            inverse: true,
                            data: labelData,
                            axisTick: {show: false},
                            axisLabel: {
                                show: false
                            },
                            axisLine: {
                                // Y轴轴线样式
                                show: false
                            }
                        },
                        {
                            type: "category",
                            gridIndex: 1,
                            inverse: true,
                            data: labelData,
                            axisTick: {show: false},
                            axisLabel: {
                                formatter: value => {
                                    var res = value;
                                    if (res.length > 5) {
                                        if (this.pageWidth > 1800) {
                                            res = res.substring(0, 7) + "...";
                                        } else if (this.pageWidth > 1520) {
                                            res = res.substring(0, 6) + "...";
                                        } else if (this.pageWidth > 1320) {
                                            res = res.substring(0, 5) + "...";
                                        } else {
                                            res = res.substring(0, 4) + "...";
                                        }
                                    }
                                    return res;
                                }
                            },
                            axisLine: {
                                show: false, //是否显示轴线
                                lineStyle: {
                                    color: "#fff",
                                    fontSize: 14,
                                    textAlign: "center"
                                }
                            }
                        }
                    ],
                    grid: [
                        {
                            top: "20%",
                            bottom: "5%",
                            width: "30%",
                            left: "7%",
                            gridIndex: 0
                        },
                        {
                            top: "20%",
                            bottom: "5%",
                            left: "60%",
                            gridIndex: 1
                        }
                    ],
                    color: ["#2FACFA", "#F5A623"],
                    series: [
                        {
                            name: "应急车辆数",
                            type: "bar",
                            barWidth: "10",
                            barMinHeight: 5,
                            gridIndex: 0,
                            itemStyle: {
                                normal: {
                                    show: true,
                                    color: new Echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                        {offset: 0, color: "#008aff"},
                                        {offset: 1, color: "#4348ff"}
                                    ]),

                                    barBorderRadius: 50,
                                    borderWidth: 0,
                                    // borderColor: "#333",
                                    label: {
                                        show: true,
                                        position: "left",
                                        color: "#fff",
                                        formatter: function (v) {
                                            return v.value * -1;
                                        }
                                    }
                                }
                            },
                            data: vehicleData
                        },
                        {
                            name: "应急司机数",
                            type: "bar",
                            barWidth: "10",
                            barMinHeight: 5,
                            xAxisIndex: 1,
                            yAxisIndex: 1,
                            itemStyle: {
                                normal: {
                                    show: true,
                                    color: new Echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                        {offset: 0, color: "#00b2d2"},
                                        {offset: 1, color: "#5fd8f6"}
                                    ]),
                                    barBorderRadius: 50,
                                    borderWidth: 0,
                                    borderColor: "#333",
                                    label: {
                                        show: true,
                                        color: "#fff",
                                        position: "right",
                                        formatter: function (v) {
                                            return v.value;
                                        }
                                    }
                                }
                            },
                            data: driverData
                        }
                    ]
                });
                const options = [];
                this.centerLeftChartInstance.setOption({
                    options
                });
            },

            // 各企业应急运力，轮播切换数据，每页展示10条数据，30s切换
            handleLoopData() {
                this.centerLeftTimer = setTimeout(() => {
                    this.loopData = this.centerLeftChartData.slice(
                        this.count,
                        this.count + 10
                    );
                    if (this.count + 10 >= this.centerLeftChartData.length) {
                        this.count = 0;
                    } else {
                        this.count += 10;
                    }
                    this.initCenterLeftChart(this.loopData);
                    this.handleLoopData();
                }, 1e3 * 30);
            },

            /************************* bottomCenter ***********************************/
            // 获取各地区报警数量统计数据
            fetchBottomCenterData() {
                this.bottomCenterLoading = true;
                FetchAlarmByLocation()
                    .then(({code, result, message}) => {
                        if (code === 1 && result) {
                            // this.bottomCenterChartData = result;
                            this.tableObj = {};
                            let data = [];

                            for (let i = 0; i < 18; i++) {
                                data.push({
                                    areaName: "RW202004402000" + i,
                                    startArea: "陕西省西安市长安区西长安街996号",
                                    startTime: "05-05 9:00至05-05",
                                    endArea: "陕西省雁塔区锦业一路丈八五路96号",
                                    endTime: "05-05 19:00至05-05",
                                    licenseId: "陕A12345" + i,
                                    dirveName: "张三",
                                    status: "运输中",
                                    planTime: "05-05 22:00",
                                    progress: "95%"
                                });
                            }

                            if (data.length > 6) {
                                let len = Math.ceil(data.length / 6);

                                for (let i = 0, j = 0; i < len; i++) {
                                    this.tableObj["table" + i] = data.slice(j, j + 6);
                                    this.tableObj["table" + i] = this.handleInitTableData(
                                        this.tableObj["table" + i]
                                    );
                                    j += 6;
                                }
                            } else {
                                this.tableObj["table1"] = data;
                                this.tableObj["table1"] = this.handleInitTableData(
                                    this.tableObj["table1"]
                                );
                            }
                        } else {
                            this.errorMessage(message || "获取各地区报警数量统计数据失败");
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.errorMessage("获取各地区报警数量统计数据失败");
                    })
                    .finally(() => {
                        this.bottomCenterLoading = false;
                    });
            },

            // 处理表格数据填充,
            handleInitTableData(arr) {
                if (arr.length < 6) {
                    for (let i = arr.length; i < 6; i++) {
                        arr.push({
                            areaName: "",
                            startArea: "",
                            startTime: "",
                            endArea: "",
                            endTime: "",
                            licenseId: "",
                            dirveName: "",
                            status: "",
                            planTime: "",
                            progress: ""
                        });
                    }
                }
                return arr;
            },
            /************************** centerRight ************************************/
            // 获取各区县在线率及温度合格率数据
            fetchBottomRightData() {
                this.centerRightLoading = true;
                FetchAlarmByScenes()
                    .then(({code, result, message}) => {
                        if (code === 1 && result) {
                            // result = {
                            //   lastDateData: {
                            //     vehicleAlarmCount: 24,
                            //     storageAlarmCount: 37,
                            //     storeAlarmCount: 43
                            //   },
                            //   last7DateData: {
                            //     vehicleAlarmCount: 145,
                            //     storageAlarmCount: 201,
                            //     storeAlarmCount: 341
                            //   },
                            //   lastMouthData: {
                            //     vehicleAlarmCount: 675,
                            //     storageAlarmCount: 824,
                            //     storeAlarmCount: 546
                            //   }
                            // };
                            this.centerRightChartData = result;
                        } else {
                            this.errorMessage(
                                message || "获取各区县在线率及温度合格率数据失败"
                            );
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.errorMessage("获取各区县在线率及温度合格率数据失败");
                    })
                    .finally(() => {
                        this.centerRightLoading = false;
                        this.initBottomRightChart();
                    });
            },
            // 初始化底部右侧图表
            initBottomRightChart() {
                if (this.centerRightChartInstance) {
                    this.centerRightChartInstance.clear();
                } else {
                    this.centerRightChartInstance = Echarts.init(
                        this.$refs.centerRightChartDOM
                    );
                    this.centerRightChartInstance.setOption({
                        tooltip: {},
                        title: {
                            text: "近7天应急任务数量",
                            textStyle: {
                                color: "#bad7ff",
                                fontSize: this.calcXDirectionSizeByPercent(16),
                                lineHeight: this.calcYDirectionSizeByPercent(30)
                            },
                            padding: [
                                this.calcYDirectionSizeByPercent(2),
                                this.calcXDirectionSizeByPercent(0),
                                0,
                                this.calcXDirectionSizeByPercent(10)
                            ]
                        },
                        xAxis: {
                            data: ["9.1", "9.2", "9.3", "9.4", "9.5", "9.6", "9.7"],
                            axisTick: {
                                show: false
                            },
                            axisLine: {
                                show: false
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    fontSize: 12,
                                    color: "rgba(255, 255, 255, 0.4)"
                                },
                                margin: 10
                            }
                        },
                        yAxis: {
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: "#7b89dc",
                                    opacity: 0.2
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            axisLine: {
                                show: false
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    fontSize: 12,
                                    color: "rgba(255, 255, 255, 0.4)"
                                }
                            }
                        },
                        series: [
                            {
                                name: "年报上报率3",
                                type: "pictorialBar",
                                symbolSize: [20, 12],
                                symbolOffset: [0, -6],
                                z: 12,
                                itemStyle: {
                                    normal: {
                                        color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            {offset: 0, color: "#60b4fb"},
                                            {offset: 1, color: "#1489fb"}
                                        ])
                                    }
                                },
                                data: [
                                    {
                                        value: 100,
                                        symbolPosition: "end"
                                    },
                                    {
                                        value: 50,
                                        symbolPosition: "end"
                                    },
                                    {
                                        value: 20,
                                        symbolPosition: "end"
                                    },
                                    {
                                        value: 30,
                                        symbolPosition: "end"
                                    },
                                    {
                                        value: 50,
                                        symbolPosition: "end"
                                    },
                                    {
                                        value: 64,
                                        symbolPosition: "end"
                                    },
                                    {
                                        value: 88,
                                        symbolPosition: "end"
                                    }
                                ]
                            },
                            {
                                name: "年报上报率2",
                                type: "pictorialBar",
                                symbolSize: [20, 12],
                                symbolOffset: [0, 6],
                                z: 12,
                                itemStyle: {
                                    normal: {
                                        color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            {offset: 0, color: "#0c6cd9"},
                                            {offset: 1, color: "#4348ff"}
                                        ])
                                    }
                                },
                                data: [100, 50, 20, 30, 50, 64, 88]
                            },
                            {
                                type: "bar",
                                itemStyle: {
                                    normal: {
                                        color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            {offset: 0, color: "#008aff"},
                                            {offset: 1, color: "#4348ff"}
                                        ]),
                                        opacity: 0.8
                                    }
                                },
                                silent: true,
                                barWidth: 20,
                                barGap: "-100%", // Make series be overlap
                                data: [100, 50, 20, 30, 50, 64, 88]
                            }
                        ]
                    });
                }

                // const options = [];
                // this.centerRightChartInstance.setOption();
            },

            // 自动轮播timeline进度更改
            chartInstanceTimelineProgressChange(type, index) {
                let chartInstance = null;
                switch (type) {
                    case "topLeft":
                        this.topLeftTimelineActiveIndex = index;
                        chartInstance = this.topLeftChartInstance;
                        break;
                    case "topRight":
                        this.topRightTimelineActiveIndex = index;
                        chartInstance = this.topRightChartInstance;
                        break;
                    case "centerLeft":
                        this.bottomLeftTimelineActiveIndex = index;
                        chartInstance = this.centerLeftChartInstance;
                        break;

                    case "centerRight":
                        this.bottomRightTimelineActiveIndex = index;
                        chartInstance = this.centerRightChartInstance;
                        break;
                }

                chartInstance &&
                chartInstance.dispatchAction({
                    type: "timelineChange",
                    currentIndex: index
                });
            },

            // 计算渐变颜色
            calcGradualChangeColor(index, length, startColor, endColor) {
                const rColor =
                    startColor[0] + ((endColor[0] - startColor[0]) / length) * index;
                const gColor =
                    startColor[1] + ((endColor[1] - startColor[1]) / length) * index;
                const bColor =
                    startColor[2] + ((endColor[2] - startColor[2]) / length) * index;

                return `rgb(${rColor}, ${gColor}, ${bColor})`;
            },

            // 计算横向尺寸百分比
            calcXDirectionSizeByPercent(size) {
                return (size / 1920) * this.clientWidth;
            },

            // 计算纵向向尺寸百分比
            calcYDirectionSizeByPercent(size) {
                return (size / 1080) * this.clientHeight;
            }
        }
    };
</script>

<style lang="scss" scoped>
    @font-face {
        font-family: "LEDNumber";
        src: url(~@/assets/ledFont/LEDNum.eot); /***兼容ie9***/
        src: url(~@/assets/ledFont/LEDNum.eot?#iefix) format("embedded-opentype"),
            /***兼容ie6-ie8***/
        url("~@/assets/ledFont/LEDNum.woff") format("woff"),
        local("LEDNum"), url("~@/assets/ledFont/LEDNum.woff"); /***默认使用本地的***/
    }

    $layout-width: 1920px;
    $layout-height: 1080px;

    .monitor-container {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #09121b;
        background-image: url("~@/assets/images/alarmBoard/bigScreenBg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;

        /*标题*/
        .title-section {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            z-index: 2;
            box-sizing: border-box;
            width: 100%;
            height: 0.83rem;
            padding-top: 0.14rem;
            background-image: url("~@/assets/images/alarmBoard/bigScreenTitleBg.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center center;

            p {
                margin: 0;
            }

            .titleInfo {
                font-family: "LEDNumber";
                color: #3f83ff;
                font-size: 0.22rem;
                word-spacing: 1em;
                margin-left: 0.35rem;
            }

            .titleText {
                width: 2.6rem;
                height: 0.3rem;
                margin: 0 auto;
                background-image: url("~@/assets/images/emergencyManage/transportMonitorBoard/title.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                background-position: center center;
            }
        }

        .main {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            box-sizing: border-box;
            width: 100%;
            height: 100%;

            p {
                margin: 0;
            }

            .chartPanel {
                &-child {
                    position: absolute;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;

                    &.topLeft {
                        left: (10px / $layout-width) * 100%;
                        top: (69px / $layout-height) * 100%;
                        width: (492px / $layout-width) * 100%;
                        height: (201px / $layout-height) * 100%;
                        background-image: url("~@/assets/images/emergencyManage/transportMonitorBoard/top-left.png");

                        .wrapper {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 100%;
                            height: 100%;

                            .left,
                            .right {
                                flex: 1;
                            }

                            .left {
                                p {
                                    color: #bad7ff;
                                    font-size: 0.16rem;
                                    text-align: right;
                                    margin: 0.43rem 0;
                                }
                            }

                            .center {
                                width: 1.19rem;
                                height: 1.69rem;
                                background: url("~@/assets/images/emergencyManage/transportMonitorBoard/top-left-bar.png") no-repeat;
                                background-size: 100% 100%;
                            }

                            .right {
                                // position: relative;
                                font-family: "Impact";
                                font-size: 0.3rem;
                                p {
                                    margin: 0.25rem 0;
                                }
                                // p {
                                //   position: absolute;
                                // }

                                // p:nth-child(1) {
                                //   top: 0.24rem;
                                // }
                                // p:nth-child(2) {
                                //   top: 0.84rem;
                                // }
                                // p:nth-child(3) {
                                //   top: 0.145rem;
                                // }

                                $class-color-list: #f1bb4c, #3bafff, #3feed4;

                                @for $i from 1 through 3 {
                                    .color_#{$i} {
                                        color: nth($class-color-list, $i);
                                    }
                                }
                            }
                        }
                    }

                    &.topRight {
                        right: (10px / $layout-width) * 100%;
                        top: (69px / $layout-height) * 100%;
                        width: (492px / $layout-width) * 100%;
                        height: (201px / $layout-height) * 100%;
                        background-image: url("~@/assets/images/emergencyManage/transportMonitorBoard/top-right.png");

                        // 内容区域
                        .wrapper {
                            display: flex;
                            justify-items: center;
                            align-items: center;
                            width: 100%;
                            height: 100%;

                            .item {
                                position: relative;
                                flex: 1;
                                height: 100%;
                                text-align: center;

                                .num {
                                    position: absolute;
                                    left: 50%;
                                    top: 50%;
                                    font-size: 0.42rem;
                                    font-family: "Impact";
                                    transform: translate(-50%, -50%);
                                }

                                .title {
                                    position: absolute;
                                    bottom: 0.2rem;
                                    left: 50%;
                                    width: 100%;
                                    transform: translateX(-50%);
                                    font-size: 0.16rem;
                                    color: #bad7ff;
                                }

                                &:nth-of-type(1) .num {
                                    color: #f1bb4c;
                                }
                                &:nth-of-type(2) .num {
                                    color: #3bafff;
                                }
                                &:nth-of-type(3) .num {
                                    color: #3feed4;
                                }

                                .chart {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                        }
                    }

                    &.middleCenter {
                        left: 0;
                        right: 0;
                        top: (70px / $layout-height) * 100%;
                        margin: 0 auto;
                        width: (930px / $layout-width) * 100%;
                        height: (635px / $layout-height) * 100%;
                    }

                    &.centerLeft {
                        left: (10px / $layout-width) * 100%;
                        top: (300px / $layout-height) * 100%;
                        width: (492px / $layout-width) * 100%;
                        height: (390px / $layout-height) * 100%;
                        background-image: url("~@/assets/images/emergencyManage/transportMonitorBoard/center-left.png");
                    }

                    &.centerRight {
                        right: (10px / $layout-width) * 100%;
                        top: (300px / $layout-height) * 100%;
                        width: (492px / $layout-width) * 100%;
                        height: (390px / $layout-height) * 100%;
                        background-image: url("~@/assets/images/emergencyManage/transportMonitorBoard/center-right.png");
                    }

                    &.bottomCenter {
                        left: 0;
                        right: 0;
                        bottom: (10px / $layout-height) * 100%;
                        margin: 0 auto;
                        width: (1900px / $layout-width) * 100%;
                        height: (350px / $layout-height) * 100%;
                        background-image: url("~@/assets/images/emergencyManage/transportMonitorBoard/center-bottom.png");

                        .title {
                            color: #bad7ff;
                            height: 0.21rem;
                            font: {
                                size: 16px;
                                weight: 600;
                            }
                            padding: 4px 0 0 11px;
                        }

                        /deep/ .el-carousel {
                            height: calc(100% - 0.25rem);
                            margin-top: 0.02rem;
                        }

                        .chartPanel__table {
                            width: 100%;
                            height: 100%;
                            font-size: 14px;
                            border-collapse: collapse;
                            text-align: center;
                            color: #ffffff;
                            .th-color {
                                color: #7b89dc;
                            }
                            thead {
                                height: 42px;
                                background-color: rgba(22, 27, 68, 0.6);
                                tr {
                                    border-bottom: 2px solid;
                                    border-image: linear-gradient(to right, #008aff, #4348ff);
                                }
                            }
                            tbody {
                                tr:nth-child(odd) {
                                    background-color: rgba(22, 27, 68, 0.4);
                                }
                                tr:nth-child(even) {
                                    background-color: rgba(22, 27, 68, 0.6);
                                }
                            }
                            tr {
                                height: 36px;
                                line-height: 36px;
                                th {
                                    // width: 20%;
                                    line-height: 41px;
                                }
                                td {
                                    // width: 20%;
                                    line-height: 36px;
                                }
                            }
                        }
                    }

                    &-slide {
                        position: absolute;
                        top: 0.07rem;
                        right: 0.25rem;
                        display: flex;
                        z-index: 10;

                        li {
                            margin-left: 0.03rem;
                            padding: 0.05rem 0.06rem;
                            font-size: 0.12rem;
                            color: #7b89dc;
                            transition: all 0.3s;
                            cursor: pointer;

                            &:hover,
                            &.active {
                                color: #fff;
                                background: #7b89dc;
                                border-radius: 0.05rem;
                            }
                        }
                    }

                    &-chartArea {
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        bottom: 0;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
</style>
